export const createUserFormConfig = [
  { name: "name", label: "Name", type: "text", required: true },
  { name: "email", label: "Email", type: "email" },
  // { name: "role", label: "Role", type: "select", options: ["Admin", "Blogger", "Truck"] },
  { name: "mobileNo", label: "Mobile Number", type: "number" },
  // { name: "role", label: "Role", type: "checkbox" },
   { name: "roles", label: "Roles", type: "multiCheckbox", options: ["Admin", "Editor", "Viewer"] }

];


export const createBlogFormConfig = [
  { name: "title", label: "Title", type: "text", required: true },
  { name: "author", label: "Author", type: "text" },
  { name: "content", label: "Content", type: "richtext" },
  { name: "categories", label: "Categories", type: "tags", placeholder: "Add categories and press Enter" },
  { name: "keywords", label: "Keywords", type: "tags", placeholder: "Add keywords and press Enter" },
  { name: "publishedDate", label: "Published Date", type: "date" },
  { name: "metaTitle", label: "Meta Title", type: "text" },
  { name: "metaDescription", label: "Meta Description", type: "text" },
  { name: "canonicalUrl", label: "Canonical URL", type: "text" },
  { name: "coverImage", label: "Cover Image", type: "file",accept:"image/*", fileType: "image" },
  { name: "featureImage", label: "Feature Image", type: "file", fileType: "image" },
  { name: "blogType", label: "Blog Type", type: "select", options: ["MOTORCYCLE", "CARS", "SAFETY","TECH"], required: true }
];
